'use strict';

angular.module('invitations', [
    'event',
    'sharecrf-sdk',
]);
